<template>
  <v-card elevation="0">
    <div class="d-flex justify-space-around">
      <span class="mr-3">
        <v-icon class="mr-2">
          mdi-calendar
        </v-icon>
        <span>{{ extractDateAndHour(modified_date).date }}</span>
      </span>
      <span class="mr-3">
        <v-icon class="mr-2">
          mdi-clock-outline
        </v-icon>
        <span>{{ extractDateAndHour(modified_date).hour }}</span>
      </span>
      <span class="mr-3">
        <v-icon class="mr-2">
          mdi-account
        </v-icon>
        <span>{{ modified_by }}</span>
      </span>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'InfoContentComponent',
  props: {
    modified_date: {
      type: String,
      default: () => '',
    },
    modified_by: {
      type: String,
      default: () => '',
    },
  },
  methods: {
    extractDateAndHour(dateISO) {
      const date = new Date(dateISO);
      const dateExtract = new Intl.DateTimeFormat('pt-BR', {
        dateStyle: 'short',
      }).format(date);
      const hourExtract = new Intl.DateTimeFormat('pt-BR', {
        timeStyle: 'short',
      }).format(date);

      return {
        date: dateExtract,
        hour: hourExtract,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
span {
  color: #a8a8a8 !important;

  i {
    color: inherit !important;
  }
}
</style>
